<template>
  <el-dialog
    class="notify-details"
    :title="currentNotify.title"
    :visible="showModal"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @close="closeModal"
  >
    <el-carousel
      ref="carousel"
      :autoplay="false"
      indicator-position="outside"
      :set-active-item="currentIndex"
      trigger="click"
      @change="changeCarousel"
    >
      <el-carousel-item v-for="(item, index) in notifyList" :key="index" :name="item.id + ''">
        <div v-viewer class="notify-content" v-html="item.content"></div>
      </el-carousel-item>
    </el-carousel>
    <div class="notify-btns">
      <el-button type="primary" :disabled="currentIndex === 0" @click="goToPrev">上一条</el-button>
      <span class="notify-progress">{{ currentIndex + 1 }}/{{ notifyList.length }}</span>
      <el-button type="primary" :disabled="currentIndex === notifyList.length - 1" @click="goToNext">下一条</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { apiReadSingleMessage } from "@/api/user"
export default {
  components: {},
  props: {
    notifyList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      currentIndex: 0, // 当前显示的条目索引
      currentNotify: {}
    }
  },
  watch: {
    notifyList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.currentNotify = newVal[this.currentIndex]
          this.showModal = true
          this.readSingleMsg(this.currentNotify.id)
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    // 切换到上一条内容
    goToPrev() {
      if (this.currentIndex > 0) {
        this.currentIndex-- // 更新索引，展示上一条
        this.currentNotify = this.notifyList[this.currentIndex] // 更新当前通知
        this.readSingleMsg(this.currentNotify.id)
      }
      this.$refs.carousel.prev() // 使用 carousel 的 prev 方法切换到上一项
    },
    // 切换到下一条内容
    goToNext() {
      if (this.currentIndex < this.notifyList.length - 1) {
        this.currentIndex++ // 更新索引，展示下一条
        this.currentNotify = this.notifyList[this.currentIndex] // 更新当前通知
        this.readSingleMsg(this.currentNotify.id)
      }
      this.$refs.carousel.next() // 使用 carousel 的 next 方法切换到下一项
    },
    changeCarousel(val) {
      this.currentIndex = val
      this.currentNotify = this.notifyList[val] // 更新当前通知
    },
    closeModal() {
      this.showModal = false
      this.$store.dispatch("user/getUnreadNotifyCount")
    },
    // 单条消息已读
    readSingleMsg(id) {
      apiReadSingleMessage({ id }).then(res => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.notify-details {
  ::v-deep {
    .el-dialog {
      width: 800px;
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%, -50%);
      // margin-top: 0 !important;
    }
    .el-carousel__container {
      height: 450px;
    }

    .el-carousel__button {
      width: 10px;
      height: 10px;
      background: rgba(50, 150, 250, 0.3);
      border-radius: 0px 0px 0px 0px;
      padding: 0;
      border-radius: 50%;
    }

    .el-carousel__indicator.is-active button {
      background: #3296fa;
    }

    .el-button--primary {
      display: flex;
      margin: 0 auto;
      margin-top: 10px;
    }

    .el-carousel__arrow {
      display: none;
    }
  }
}

.notify-btns {
  width: 300px;
  margin: 0 auto;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .notify-progress {
    margin-top: 8px;
  }
}
.notify-content {
  height: 450px;
  overflow-y: auto;
  margin-top: 10px;
  padding-bottom: 30px;
  ::v-deep img {
    max-width: 100%;
  }
}
</style>
